module.exports = __webpack_public_path__ + "static/media/400381_01.a4aa697f.png";